export const FinanceData = [
  {
    title: "Must and should",
    subtitle: "a developer guide",
    filepath: "/dsa/must.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },

  {
    title: "Payment-systems",
    subtitle: "a realtime payment system",
    filepath: "/Finance/payment.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "Payment-solid principles",
    subtitle: "a medium article",
    filepath: "/Finance/overview.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "Git",
    subtitle: "How git works",
    filepath: "/dsa/git.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "HTML",
    subtitle: "My Understanding of Html",
    filepath: "/dsa/html.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "CSS",
    subtitle: "My Understanding of CSS",
    filepath: "/dsa/css.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "JavaScript",
    subtitle: "My Understanding of CSS",
    filepath: "/dsa/js.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
];
